import { useEffect } from "react";
import styled from "styled-components";

import { showBackButtonWith } from "../telegram/sdk";

// Overlay modal used for the Riddle screen (and gates). Wires the Telegram
// BackButton to `onClose` while mounted, and closes on backdrop tap / Escape.
const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(2, 4, 8, 0.72);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const Sheet = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth};
  max-height: 90vh;
  overflow-y: auto;
  background: ${({ theme }) => theme.color.surface};
  border: 1px solid ${({ theme }) => theme.color.border};
  border-bottom: none;
  border-radius: ${({ theme }) => `${theme.radius.lg} ${theme.radius.lg} 0 0`};
  padding: ${({ theme }) => theme.space(5)};
  padding-bottom: calc(${({ theme }) => theme.space(5)} + env(safe-area-inset-bottom));
  animation: rise 0.18s ease-out;

  @keyframes rise {
    from {
      transform: translateY(16px);
      opacity: 0.6;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export function Modal({
  onClose,
  closeOnBackdrop = true,
  children,
}: {
  onClose: () => void;
  closeOnBackdrop?: boolean;
  children: React.ReactNode;
}) {
  useEffect(() => {
    const cleanup = showBackButtonWith(onClose);
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      cleanup();
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return (
    <Backdrop onClick={closeOnBackdrop ? onClose : undefined}>
      <Sheet onClick={(e) => e.stopPropagation()}>{children}</Sheet>
    </Backdrop>
  );
}
